@for (slotId of slots?.slotIds; track slotId) {
  <div
    class="{{ slotsExpressionVisibilityClass?.[slotId] }}"
    [blazeSlotNode]="slots?.slotNodesData?.[slotId]"
    [viewportMode]="viewportMode"
    [ngStyle]="createStylesForSlot(slotId)"
  >
    <ng-container *ngTemplateOutlet="slots?.templates?.[slotId] || null" />
  </div>
}
